import { render, staticRenderFns } from "./AccordionStatiz.vue?vue&type=template&id=0beab325&"
import script from "./AccordionStatiz.vue?vue&type=script&lang=js&"
export * from "./AccordionStatiz.vue?vue&type=script&lang=js&"
import style0 from "./AccordionStatiz.vue?vue&type=style&index=0&id=0beab325&prod&lang=scss&scoper=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardTitle,VExpandTransition,VIcon,VProgressLinear})
